 import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Footer from 'src/components/Footer';

import Navbar from 'src/components/Navbar';
import ServicesSection from 'src/components/ServicesSection';
import Sidebar from 'src/components/Sidebar';
import { Colors, LoadIcon } from 'src/styles/DesignSystem';
import About from './About';
import Banner from './Banner';
import Delivery from './Delivery';

const Home = () => {

    
    // Controles do menu
    const [isOpen, setIsOpen] = useState(false);
    const toggle = ()=>{
        setIsOpen(!isOpen);
    }

    // Controles de dados
    const [infosHome, setInfosHome] = useState({});
    const [servicos, setServicos] = useState({});
    const [about, setAbout] = useState({});
    const [isLoaded, setIsLoaded] = useState(false);

    // Controle de Requisições

    useEffect(() => {
        const fetching = () => {
            axios.all(
                [
                    axios.get('https://hipermercadodasracoes.com/system/wp-json/wp/v2/home-infos'), 
                    axios.get('https://hipermercadodasracoes.com/system/wp-json/wp/v2/servicos'), 
                    axios.get('https://hipermercadodasracoes.com/system/wp-json/wp/v2/sobre')
                ]
            ).then(axios.spread((...responses) => {
                setInfosHome(responses[0].data[0]);
                setServicos(responses[1].data);
                setAbout(responses[2].data[0]);
                setIsLoaded(true);
                // use/access the results 
            })).catch(errors => {
                // react on errors.
            })
        };
        fetching();
    }, []);

    
    if(!isLoaded){
        return(
          <>
            <LoadIcon />
          </>
        )
    }
    return (
        <>
            {
                !isLoaded ?
                    <LoadIcon />
                :
                <>
                    <Navbar isOpen = {isOpen} toggle={toggle} page="home"/>
                    <Sidebar isOpen = {isOpen} toggle={toggle} page='home'/>

                    {/* Conteudo da pagina */}
                    <Banner 
                        title={infosHome.title.rendered}
                        subtitle={infosHome.acf.subtitulo}
                    />
                    <ServicesSection
                        title={infosHome.title.rendered}
                        subtitle={infosHome.acf.subtitulo}
                        titleColor={Colors.brown}
                        padding={3.5}
                        services={servicos}
                    />
                    <Delivery />

                    <Footer 
                        firtsComponent={
                            <About 
                                about={about.acf.sobre} 
                                mainImage = {infosHome.acf.imagens_institucionais.main_image}
                                img01 = {infosHome.acf.imagens_institucionais.image_01}
                                img02 = {infosHome.acf.imagens_institucionais.image_02}
                                img03 = {infosHome.acf.imagens_institucionais.image_03}
                            />
                        }
                    />
                </>
            }
        </>        
    )
}

export default Home;